import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { useAuth } from '../lib/auth';
import styles from './AppShell.module.css';

/**
 * Authenticated app shell — Board chrome: single top bar (brand + module
 * tabs + user area), full-width content below. Wrapped by
 * <ProtectedRoute /> in router.tsx, which guarantees `user` is set.
 */
export function AppShell() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className={styles.shell}>
      <TopBar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
